import Image from "next/image";
import Link from "@components/ui-old/link";
import cn from "classnames";
import { siteSettings } from "@settings/site-settings";
const Logo: React.FC<React.AnchorHTMLAttributes<{}>> = ({
  className,
  ...props
}) => {
  return <Link href={siteSettings.logo.href} className={cn("inline-flex focus:outline-none", className)} {...props} data-sentry-element="Link" data-sentry-component="Logo" data-sentry-source-file="logo.tsx">
            <Image src="/assets/images/logo.svg" alt={siteSettings.logo.alt} height={siteSettings.logo.height} width={siteSettings.logo.width} loading="eager" className="block dark:hidden" data-sentry-element="Image" data-sentry-source-file="logo.tsx" />
            <Image src="/assets/images/logo-white.svg" alt={siteSettings.logo.alt} height={siteSettings.logo.height} width={siteSettings.logo.width} loading="eager" className="hidden dark:block" data-sentry-element="Image" data-sentry-source-file="logo.tsx" />
        </Link>;
};
export default Logo;